((app, ng) => {

    app.controller("figAccountController", figAccountController);

    function figAccountController($q, $mdDialog, externalAccountApi) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.openRequirements = [];
            $ctrl.completedRequirements = [];
            $ctrl.ui = {
                loading: true,
            }

            const promises = [
                externalAccountApi.getFigAccount($ctrl.arcPolicyGuid),
                externalAccountApi.getArcPolicyRequirements($ctrl.arcPolicyGuid),
            ];

            $q.all(promises).then(responses => {
                $ctrl.account = responses[0];

                $ctrl.openRequirements = responses[1].filter(requirement => !requirement.Completed);

                $ctrl.completedRequirements = responses[1].filter(requirement => requirement.Completed);

                $ctrl.ui.loading = false;
            });
        }

        const close = () => { 
            $mdDialog.hide();
        }

        ng.extend($ctrl,
            {
                close, 
            });
    }
})(window.app, window.angular);